import React, { Fragment } from "react";
import { Helmet } from "react-helmet";
import { Fade } from "react-reveal";
import { Link } from "react-router-dom";

function Fio() {
    const metaData = {
        title: '',
        description: ''
    }
    return (
        <Fragment>
            <Helmet>
                <title>{metaData.title}</title>
                <meta name="description" content={metaData.description} />
            </Helmet>
            <div className="container-fluid faderight">
                <div className="row">
                    <div className='col-sm-12 heads govbanner shariah'>
                        <Fade up delay={500}><h2 className="oswald">Federal Insurance Ombudsman</h2></Fade>
                    </div>
                    <div className='container' >
                        <div className='row arrticleAndBlogs fio'>
                            <div className="col-sm-12">
                                <Link to='https://fio.gov.pk/' target="_blank">
                                    <img src={`${process.env.REACT_APP_URL_ASSETS}Assets/img/FIONewPage.png`} alt=""/>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default Fio;